<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- GO BACK BUTTON -->
<p-toolbar styleClass="p-mb-4">
    <ng-template pTemplate="left">
        <!-- BACk -->
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="redirect()"></button>

        <!-- SAVE -->
        <button pButton pRipple label="{{translations.lbl_update}}" icon="pi pi-plus" class="p-button-success p-mr-2"
            (click)="saveRecord()"></button>

        <!-- CLOSE -->
        <button pButton pRipple label="{{translations.lbl_close}}" class="p-button-error p-mr-2"></button>
    </ng-template>
</p-toolbar>

<p-fieldset>
    <!-- HEADER -->
    <ng-template pTemplate="header">{{this.titleName}}</ng-template>
    <p-tabView>
        <p-tabPanel header="{{translations.lbl_national_coordination}}">
            <!-- MAIN SCREEN -->
            <div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">
                <!-- MAIN CONTENT -->
                <div class="p-grid">
                    <!-- DATA FORM -->
                    <div class="p-xl-6 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <h6>Ingrese los datos</h6>

                        <!-- STORE ID -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_id}} {{translations.lbl_store}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input type="text" pInputText formControlName="storeId">
                            </div>
                        </div>

                        <!-- NATIONAL Id -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_coordination}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <input type="text" pInputText formControlName="natId">
                            </div>
                        </div>

                        <!-- SUPERIOR COORDINATION -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_superior_coordination}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-dropdown id="superiorCoord" [options]="zonalCoords" [showClear]="true"
                                    formControlName="superiorCoord"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_store}}"
                                    optionLabel="descrip"></p-dropdown>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('superiorCoord')?.errors?.required && globalUserDataForm.get('superiorCoord')?.touched">Superior
                                Coordination is required</small>
                        </div>

                        <!-- NAME -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_name}}</span>
                                <!-- Podria ponerse como ´Nombre´ -->
                            </div>

                            <div class="p-col-12 p-md-8 p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text" pInputText formControlName="coordName">
                                </span>
                                <span class="p-inputgroup-addon"><i class="pi pi-tag"></i></span>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('coordName')?.errors?.maxlength && globalUserDataForm.get('coordName')?.touched">Input
                                length exceeded</small>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('coordName')?.errors?.minlength && globalUserDataForm.get('coordName')?.touched">Input
                                length is too short</small>
                        </div>

                        <!-- SHORT NAME -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_short_Name}}</span>
                            </div>

                            <div class="p-col-12 p-md-8 p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text" pInputText formControlName="shortName">
                                </span>
                                <span class="p-inputgroup-addon"><i class="pi pi-pencil"></i></span>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('shortName')?.errors?.maxlength && globalUserDataForm.get('shortName')?.touched">Input
                                length exceeded</small>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('shortName')?.errors?.minlength && globalUserDataForm.get('shortName')?.touched">Input
                                length is too short</small>
                        </div>

                        <!-- DATE START -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_starting_date}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-calendar [showIcon]="true" dateFormat="yy-mm-dd" formControlName="begDate"
                                    [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030"
                                    inputId="navigators"></p-calendar>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('begDate')?.errors?.required && globalUserDataForm.get('begDate')?.touched">Date
                                is required</small>
                        </div>

                        <!-- COUNTRY -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_country}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-dropdown id="country" [options]="countries" [showClear]="true"
                                    formControlName="country" placeholder="Seleccione un país"
                                    optionLabel="descrip"></p-dropdown>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('country')?.errors?.required && globalUserDataForm.get('country')?.touched">Country
                                is required</small>
                        </div>

                        <!-- COORDINATOR EMAIL -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_email}} {{translations.lbl_coordinator}}</span>
                            </div>

                            <div class="p-col-12 p-md-8 p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text" pInputText formControlName="coordEmail">
                                </span>
                                <span class="p-inputgroup-addon"><i class="pi pi-envelope"></i></span>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('coordEmail')?.errors?.pattern && globalUserDataForm.get('coordEmail')?.touched">Email
                                is not valid</small>
                        </div>

                        <!-- SECRETARY EMAIL -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_email}} {{translations.lbl_secretary}}</span>
                            </div>

                            <div class="p-col-12 p-md-8 p-inputgroup">
                                <span class="p-float-label">
                                    <input type="text" pInputText formControlName="secreEmail">
                                </span>
                                <span class="p-inputgroup-addon"><i class="pi pi-envelope"></i></span>
                            </div>
                            <div class="subTitle p-col-12 p-md-4"></div>
                            <small class="p-col-12 p-md-8 p-error"
                                *ngIf="globalUserDataForm.get('secreEmail')?.errors?.pattern && globalUserDataForm.get('secreEmail')?.touched">Email
                                is not valid</small>
                        </div>

                        <!-- INPUT WAREHOUSE ADDRESS -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_main_address}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText formControlName="coordMainAddress" disabled />
                                    <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-down"
                                        class="p-button-success p-mr-2" (click)="openMainDialog()"></button>
                                </div>
                            </div>
                        </div>


                        <!-- COMMENTS -->
                        <!-- <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span> {{translations.lbl_comments}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <div class="p-inputgroup">
                                    <textarea rows="5" cols="30" pInputTextarea></textarea>
                                </div>
                            </div>
                        </div> -->
                    </div>

                    <!-- WAREHOUSE FORM -->
                    <div class="p-xl-6 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">
                        <h6>{{translations.lbl_store}}</h6>
                        <!-- INVENTORY TYPE -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>¿Tiene Inventario Fisico/Virtual?</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <p-toggleButton onLabel="{{translations.lbl_yes}}" offLabel="{{translations.lbl_no}}"
                                    formControlName="coordInventory"></p-toggleButton>
                            </div>
                        </div>


                        <!-- INPUT WAREHOUSE ADDRESS -->
                        <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                            *ngIf="globalUserDataForm.get('coordInventory').value == true">
                            <div class="subTitle p-col-12 p-md-4">
                                <span>{{translations.lbl_address}} {{translations.lbl_store}}</span>
                            </div>
                            <div class="p-col-12 p-md-8">
                                <div class="p-inputgroup">
                                    <input type="text" pInputText id="address_dialog_telephone_number"
                                        formControlName="coordWarehouseAddress" disabled />
                                    <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-down"
                                        class="p-button-success p-mr-2" (click)="openWarehouseDialog()"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </p-tabPanel>

        <!-- TAB DE EQUIPO ZONAL -->
        <p-tabPanel header="{{translations.lbl_national_teams }}">
            <div class="card">

                <!-- ACCORDION -->
                <p-accordion [multiple]="true">
                    <!-- ACCORDION LISTA COORDINADORES -->
                    <p-accordionTab header="{{translations.lbl_list}} {{translations.lbl_coordinator}}"
                        [selected]="true">
                        <!-- TABLA LISTA COORDINADORES -->
                        <p-table *ngIf="globalUserDataForm.get('lstTeamZone').value != null" #dt
                            [value]="this.globalUserDataForm.get('lstTeamZone').value" [rows]="20" [paginator]="true"
                            [globalFilterFields]="['nameFunction','nameGuide']" [rowHover]="true" dataKey="storeId"
                            styleClass="p-datatable-responsive-demo"
                            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
                            [showCurrentPageReport]="true">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    <h5 class="p-m-0">{{translations.lbl_list}} {{translations.lbl_coordinator}}</h5>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </div>
                            </ng-template>
                            <!-- HEADERS -->
                            <ng-template pTemplate="header">
                                <tr>
                                    <!--th pSortableColumn="storeId">id Zona <p-sortIcon field="storeId"></p-sortIcon></th-->
                                    <th pSortableColumn="nameFunction">{{translations.lbl_role}} <p-sortIcon
                                            field="nameFunction"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="nameGuide">{{translations.lbl_name}} <p-sortIcon
                                            field="nameGuide"></p-sortIcon></th>
                                    <th pSortableColumn="dateBegin">{{translations.lbl_starting_date}} <p-sortIcon
                                            field="dateBegin"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="dateEnd">{{translations.lbl_ending_date}}<p-sortIcon
                                            field="dateEnd"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="comment"> {{translations.lbl_comments}} <p-sortIcon
                                            field="comment"></p-sortIcon></th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <!-- BODY -->
                            <ng-template pTemplate="body" let-guide>
                                <tr>
                                    <td>{{guide.nameFunction}}</td>
                                    <td>{{guide.nameGuide}}</td>
                                    <td>{{guide.dateBegin}}</td>
                                    <td>{{guide.dateEnd}}</td>
                                    <td>{{guide.comment}}</td>
                                    <td>
                                        <button pButton wd icon="pi pi-pencil"
                                            class="p-button-rounded p-button-success p-mr-2"
                                            (click)="editGuide(guide)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    {{translations.lbl_there_are}} {{this.globalUserDataForm.get('lstTeamZone').value !=
                                    null ?
                                    this.globalUserDataForm.get('lstTeamZone').value.length : 0 }}
                                    {{translations.lbl_records}}.
                                </div>
                            </ng-template>
                        </p-table>
                    </p-accordionTab>
                    <!-- ACCORDION MIEMBROS AUXILIARES-->
                    <p-accordionTab header="{{translations.lbl_aux_members}}">
                        <!-- TABLA MIEMBROS AUXILIARES -->
                        <p-table *ngIf="this.globalUserDataForm.get('lstAuxMembers').value != null" #dt
                            [value]="this.globalUserDataForm.get('lstAuxMembers').value" [rows]="20" [paginator]="true"
                            [globalFilterFields]="['nameFunction','nameGuide']" [rowHover]="true" dataKey="storeId"
                            styleClass="p-datatable-responsive-demo"
                            currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
                            [showCurrentPageReport]="true">
                            <ng-template pTemplate="caption">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    <h5 class="p-m-0">{{translations.lbl_aux_members}}</h5>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </div>
                            </ng-template>
                            <!-- HEADERS -->
                            <ng-template pTemplate="header">
                                <tr>
                                    <!--th pSortableColumn="storeId">id Zona <p-sortIcon field="storeId"></p-sortIcon></th-->
                                    <th pSortableColumn="nameFunction">{{translations.lbl_role}} <p-sortIcon
                                            field="nameFunction"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="nameGuide">{{translations.lbl_name}} <p-sortIcon
                                            field="nameGuide"></p-sortIcon></th>
                                    <th pSortableColumn="dateBegin">{{translations.lbl_starting_date}} <p-sortIcon
                                            field="dateBegin"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="dateEnd">{{translations.lbl_ending_date}}<p-sortIcon
                                            field="dateEnd"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="comment"> {{translations.lbl_comments}} <p-sortIcon
                                            field="comment"></p-sortIcon></th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <!-- BODY -->
                            <ng-template pTemplate="body" let-guide>
                                <tr>
                                    <td>{{guide.nameFunction}}</td>
                                    <td>{{guide.nameGuide}}</td>
                                    <td>{{guide.dateBegin}}</td>
                                    <td>{{guide.dateEnd}}</td>
                                    <td>{{guide.treastName}}</td>
                                    <td>{{guide.comment}}</td>
                                    <td>
                                        <button pButton pRipple icon="pi pi-pencil"
                                            class="p-button-rounded p-button-success p-mr-2"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    {{translations.lbl_there_are}} {{this.globalUserDataForm.get('lstTeamZone').value !=
                                    null ?
                                    this.globalUserDataForm.get('lstTeamZone').value.length : 0 }}
                                    {{translations.lbl_records}}.
                                </div>
                            </ng-template>
                        </p-table>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </p-tabPanel>
    </p-tabView>

    <!-- MODAL PARA LAS DIRECCIONES PRINCIPAL Y BODEGA -->
    <p-dialog [(visible)]="addressDialog" [style]="{width: '550px'}" header="{{translations.lbl_address}}"
        [modal]="true" styleClass="p-fluid" (onHide)="clearModalValues()">
        <ng-template pTemplate="content" [formGroup]="globalUserDataForm">
            <!-- Pais -->
            <div class="field p-text-bold">
                <label for="country">{{translations.lbl_country}}</label>
                <p-autoComplete id="address_dialog_country" formControlName="addressDialogCountry"
                    [suggestions]="filteredCountries" (completeMethod)="searchCountry($event)"
                    (onSelect)="getStatesByCountryId()" [dropdown]="true"></p-autoComplete>
            </div>

            <!-- Estado/Depto/Provincia -->
            <div class="field p-text-bold">
                <label for="address_dialog_state">{{translations.lbl_state}}</label>
                <p-autoComplete id="address_dialog_state" formControlName="addressDialogState"
                    [suggestions]="filteredStates" (completeMethod)="searchStates($event)"
                    (onSelect)="getCitiesByCountryState()" [dropdown]="true"></p-autoComplete>
            </div>

            <!-- Municipio/Alcaldia/Poblacion -->
            <div class="field p-text-bold">
                <label for="addressDialogCity">{{translations.lbl_county_city}}</label>
                <p-autoComplete formControlName="addressDialogCity" [suggestions]="filteredCities"
                    (completeMethod)="searchCities($event)" (onSelect)="selectCounty()"
                    [dropdown]="true"></p-autoComplete>
            </div>

            <!-- Colonia/Barrio/Pueblo -->
            <div class="field p-text-bold">
                <label for="address_dialog_neightborhood">{{translations.lbl_neightborhood}}</label>
                <input formControlName="addressDialogNeightborhood" pInputText type="text">
            </div>

            <!-- Calle y Numero -->
            <div class="field p-text-bold">
                <label for="address_dialog_street">{{translations.lbl_street_and_number}}</label>
                <input formControlName="addressDialogStreet" pInputText type="text">
            </div>

            <!-- Codigo Postal -->
            <div class="field p-text-bold">
                <label for="address_dialog_zip_code">{{translations.lbl_zip_code}}</label>
                <input type="text" pInputText id="address_dialog_zip_code" formControlName="addressDialogZipCode" />
            </div>

        </ng-template>
        <ng-template pTemplate="footer">
            <div class="button-container">
                <button type="button" pButton pRipple icon="pi pi-save" label="{{translations.lbl_update}}"
                    (click)="setAddress()" class="p-button-success p-m-2 button-save"
                    pTooltip="{{translations.lbl_update}}" tooltipPosition="bottom"></button>
            </div>
        </ng-template>
    </p-dialog>
</p-fieldset>


<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>